import React from "react";
import { useNavigate } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";
import Button from "style-guide/component/Button";

interface ICreateProject {
  className?: string;
  showText?: boolean;
}

const CreateProject: React.FC<ICreateProject> = ({
  className,
  showText = true,
}) => {
  const navigate = useNavigate();

  const handleCreateRfp = () => {
    document.cookie = "rfp_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    localStorage.clear();
    navigate("/landing-page");
  };

  return (
    <Button
      onClick={handleCreateRfp}
      type="Primary"
      buttonText={showText ? "New" : undefined}
      icon
      iconComponent={<PlusOutlined />}
      className={className}
    />
  );
};

export default CreateProject;
